import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { Alert } from 'antd';
import React from 'react';
import { RECURLY_PUBLIC_API_KEY } from '../../settings/config';
import PayPalForm from './PayPalForm';
import { Token } from '../types';

type Props = {
    buttonLabel: string;
    hideAlert?: boolean;
    onToken: (token: Token) => void;
};

export default function PayPalPaymentMethod({ buttonLabel, hideAlert, onToken }: Props) {
    return (
        <>
            {!hideAlert && (
                <Alert
                    message=""
                    className="paypal-notice"
                    description={`After clicking the "${buttonLabel}" button, you will be taken to the PayPal website to authorize a billing agreement. Please make sure pop-ups aren't blocked!`}
                    type="info"
                    showIcon
                />
            )}

            <RecurlyProvider publicKey={RECURLY_PUBLIC_API_KEY}>
                <Elements>
                    <PayPalForm
                        onToken={onToken}
                        buttonLabel={buttonLabel}
                    />
                </Elements>
            </RecurlyProvider>
        </>
    );
}
